import extra1 from "@/assets/tayrona-extra1.avif";
import extra2 from "@/assets/tayrona-extra2.avif";
import extra3 from "@/assets/tayrona-extra3.avif";
import extra4 from "@/assets/tayrona-extra4.avif";

/**
 * Photo mosaic (DESIGN.md). Only our own photos taken inside the park: the
 * old gallery mixed in stock Caribbean photos that weren't Tayrona, dropped
 * on 2026-10-06. Alt text and captions are the ones the old gallery used.
 */
const OWN_CREDIT = "Foto propia";

const photos = [
  {
    src: extra1,
    alt: "Vista panorámica de Camping Parque Tayrona con aguas color turquesa",
    caption: "Paisaje icónico del Parque Tayrona",
  },
  {
    src: extra2,
    alt: "Mirador de techo de palma sobre la roca de Cabo San Juan, entre dos bahías con bañistas",
    caption: "Mirador de Cabo San Juan",
  },
  {
    src: extra3,
    alt: "Playa de Cabo San Juan: aguas turquesas, rocas de granito y carpas en la orilla",
    caption: "Playa Cabo San Juan",
  },
  {
    src: extra4,
    alt: "Vista panorámica de una bahía rocosa entre montañas boscosas y el mar Caribe abierto",
    caption: "Montaña y mar en la costa del parque",
  },
];

const ImageGallery = () => (
  <section id="gallery" aria-labelledby="gallery-heading" className="pq-section">
    <div className="pq-wrap" style={{ display: "grid", gap: 40 }}>
      <div style={{ display: "grid", gap: 16 }}>
        <h2 id="gallery-heading" className="pq-headline">
          Descubre la belleza del Parque Tayrona.
        </h2>
        <p className="pq-lead">
          Fotos que tomamos dentro del parque: bahías, el mirador de Cabo San Juan
          y la montaña que baja al mar.
        </p>
      </div>
      <div className="pq-mosaic">
        {photos.map((p) => (
          <figure key={p.caption} className="pq-mosaic-item">
            <img src={p.src} alt={p.alt} loading="lazy" decoding="async" />
            <figcaption>
              {p.caption} <span>· {OWN_CREDIT}</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);

export default ImageGallery;
